<h2 mat-dialog-title>Einmalpasswort senden</h2>
<mat-dialog-content class="dialog-content">
  <mat-icon color="primary">key</mat-icon>
  <p>
    Für <strong>{{ data?.user?.username }}</strong> wird ein neues Einmalpasswort erzeugt und per E-Mail versendet.
    Der Benutzer muss sich anschließend mit dem zugesandten Passwort anmelden und ein neues Passwort vergeben.
  </p>
  <p class="hint-text">Bisherige Passwörter bleiben unverändert, bis der Benutzer das Einmalpasswort verwendet.</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">Einmalpasswort senden</button>
</mat-dialog-actions>
